import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIResponse } from '../interfaces/api.interface';
import {
  OrganisationDet,
  OrganisationDetCreate,
  OrganisationDetUpdate,
} from '../interfaces/organisation-det.interface';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class OrganisationDetService {
  public constructor(private readonly api: ApiService) {}

  public getAll(organisationId: string): Observable<APIResponse<OrganisationDet[]>> {
    return this.api.get(`admin/organisations/${organisationId}/dets`);
  }

  public getOne(organisationId: string, id: string): Observable<OrganisationDet> {
    return this.api.get(`admin/organisations/${organisationId}/dets/${id}`);
  }

  public create(organisationId: string, payload: OrganisationDetCreate): Observable<OrganisationDet> {
    return this.api.post(`admin/organisations/${organisationId}/dets`, payload);
  }

  public update(organisationId: string, id: string, payload: OrganisationDetUpdate): Observable<OrganisationDet> {
    return this.api.put(`admin/organisations/${organisationId}/dets/${id}`, payload);
  }
}
